import { render, staticRenderFns } from "./lab_inform.vue?vue&type=template&id=37f41aea&scoped=true&"
import script from "./lab_inform.vue?vue&type=script&lang=js&"
export * from "./lab_inform.vue?vue&type=script&lang=js&"
import style0 from "./lab_inform.vue?vue&type=style&index=0&lang=less&"
import style1 from "./lab_inform.vue?vue&type=style&index=1&id=37f41aea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f41aea",
  null
  
)

export default component.exports